var _rect, _rect2, _path, _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextBgDesk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 599,
    height: 374,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 45,
    width: 600,
    height: 431,
    rx: 26.19,
    fill: "url(#text-bg-desk_svg__paint0_linear_4360_13024)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: -89,
    width: 161,
    height: 250,
    rx: 26.19,
    fill: "url(#text-bg-desk_svg__paint1_linear_4360_13024)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.784 152.17L23.78 121l17.996 31.17H5.784z",
    stroke: "#904CFF",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 599,
    cy: 311,
    r: 23.636,
    stroke: "#904CFF",
    strokeWidth: 4.727
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "text-bg-desk_svg__paint0_linear_4360_13024",
    x1: 324,
    y1: 45,
    x2: 324,
    y2: 476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#3520F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866,
    stopColor: "#6521C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "text-bg-desk_svg__paint1_linear_4360_13024",
    x1: 656.5,
    y1: -89,
    x2: 656.5,
    y2: 161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#8000E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866,
    stopColor: "#5334F4"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTk5IiBoZWlnaHQ9IjM3NCIgdmlld0JveD0iMCAwIDU5OSAzNzQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIHN0eWxlPSJtaXgtYmxlbmQtbW9kZTpvdmVybGF5Ij4KPHJlY3QgeD0iMjQiIHk9IjQ1IiB3aWR0aD0iNjAwIiBoZWlnaHQ9IjQzMSIgcng9IjI2LjE5IiBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXJfNDM2MF8xMzAyNCkiLz4KPC9nPgo8cmVjdCB4PSI1NzYiIHk9Ii04OSIgd2lkdGg9IjE2MSIgaGVpZ2h0PSIyNTAiIHJ4PSIyNi4xOSIgZmlsbD0idXJsKCNwYWludDFfbGluZWFyXzQzNjBfMTMwMjQpIi8+CjxwYXRoIGQ9Ik01Ljc4NCAxNTIuMTdMMjMuNzgwMSAxMjFMNDEuNzc2MiAxNTIuMTdINS43ODRaIiBzdHJva2U9IiM5MDRDRkYiIHN0cm9rZS13aWR0aD0iMyIvPgo8Y2lyY2xlIGN4PSI1OTkiIGN5PSIzMTEiIHI9IjIzLjYzNjQiIHN0cm9rZT0iIzkwNENGRiIgc3Ryb2tlLXdpZHRoPSI0LjcyNzI3Ii8+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfNDM2MF8xMzAyNCIgeDE9IjMyNCIgeTE9IjQ1IiB4Mj0iMzI0IiB5Mj0iNDc2IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIG9mZnNldD0iMC4wMDc2MDUxNyIgc3RvcC1jb2xvcj0iIzM1MjBGOSIvPgo8c3RvcCBvZmZzZXQ9IjAuODY1ODk2IiBzdG9wLWNvbG9yPSIjNjUyMUM0Ii8+CjwvbGluZWFyR3JhZGllbnQ+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQxX2xpbmVhcl80MzYwXzEzMDI0IiB4MT0iNjU2LjUiIHkxPSItODkiIHgyPSI2NTYuNSIgeTI9IjE2MSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBvZmZzZXQ9IjAuMDA3NjA1MTciIHN0b3AtY29sb3I9IiM4MDAwRTUiLz4KPHN0b3Agb2Zmc2V0PSIwLjg2NTg5NiIgc3RvcC1jb2xvcj0iIzUzMzRGNCIvPgo8L2xpbmVhckdyYWRpZW50Pgo8L2RlZnM+Cjwvc3ZnPgo=";
export { SvgTextBgDesk as ReactComponent };